import {
  ConnectedPosition,
  Overlay,
  OverlayConfig,
  OverlayRef,
} from '@angular/cdk/overlay';
import { ComponentPortal, ComponentType } from '@angular/cdk/portal';
import {
  ElementRef,
  Injectable,
  InjectionToken,
  Injector,
  ValueProvider,
  inject,
} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OverlayService {
  private opened?: OverlayRef;
  private readonly overlay = inject(Overlay);

  openOverlay(
    toggle: ElementRef | undefined,
    component: ComponentType<unknown>,
    id: string,
    containerToken: InjectionToken<OverlayRef>,
    positions: ConnectedPosition[],
    providers?: ValueProvider[],
  ): OverlayRef | undefined {
    if (!toggle) {
      return undefined;
    }

    const isSame =
      this.opened?.getConfig().panelClass === id && this.opened?.hasAttached();

    this.opened?.dispose();

    if (isSame) {
      return undefined;
    }

    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(toggle)
      .withPositions(positions);

    const overlayRef = this.overlay.create(
      new OverlayConfig({
        positionStrategy,
        scrollStrategy: this.overlay.scrollStrategies.reposition(),
        disposeOnNavigation: true,
        panelClass: id,
      }),
    );

    overlayRef.attach(
      new ComponentPortal(
        component,
        null,
        Injector.create({
          providers: [
            ...(providers ?? []),
            {
              provide: containerToken,
              useValue: overlayRef,
            },
          ],
        }),
      ),
    );

    this.opened = overlayRef;

    return overlayRef;
  }
}
